import { gql } from '@apollo/client';
export const GET_ORDER_DETAILS_QUERY = gql `
  query canxGetOrderDetails($order_id: Int!) {
    canx_get_order_details(order_id: $order_id) {
      id
      status
      order_items {
        item_id
        order_id
        unit_price
        total_price
        quantity
        item {
          id
          status
          eligible_refund_rule {
            refund_percent
            timeframe
            amount
          }
          drive_occurrence_guest {
            id
            instruction
            reschedule_instruction
            cancel_instruction
            drive_schedule {
              id
              booking_end_date
              booking_start_date
              drive_type
              end_date
              name
              start_date
              status
              timezone
              workflow_step_id
              location
              slot_capacity
              slot_duration
            }
            drive_occurrence {
              drive_schedule_id
              end_date
              start_date
              status
              workflow_step_id
            }
          }
          sku {
            name
            refund_rules {
              refund_percent
              timeframe
            }
            reschedule_rules {
              fee_percent
              timeframe
            }
            currency_code
            plan_type
          }
          eligible_reschedule_rule {
            fee_percent
            timeframe
            amount
          }
        }
      }
      transactions {
        currency_code
        payment_id
        external_id
        status
        total_amount
        type
        invoices {
          id
          invoice_number
        }
      }
    }
  }
`;
export const CREATE_TRANSACTION_MUTATION = gql `
  mutation createTransaction($orderId: Int!, $coupon_code: String) {
    pay_create_transaction(order_id: $orderId, coupon_code: $coupon_code) {
      order_id
      payment_id
      transaction_external_id
      payment_gateway_type
      payment_url
    }
  }
`;
export const VALIDATE_COUPON_MUTATION = gql `
  mutation validateCoupon($orderId: Int!, $couponCode: String!) {
    pay_validate_coupon(order_id: $orderId, coupon_code: $couponCode) {
      order_id
      coupon_code
      order_items {
        id
        order_item_id
        item_id
        unit_price
        order_id
        coupon_id
        quantity
        total_price
      }
    }
  }
`;
export const PAYMENT_RESCHEDULED_SLOT = gql `
  mutation paymentRescheduledSlot($driveOccGuestId: Int!) {
    canx_reschedule_drive_guest(drive_occurrence_guest_id: $driveOccGuestId) {
      drive_occurrence_guest_id
      pay_item {
        id
        order_items {
          item_id
          order_id
          order {
            status
            transactions {
              currency_code
              total_amount
              external_id
              payment_id
              status
              type
            }
            id
          }
        }
      }
    }
  }
`;
export const GET_PAYMENT_INVOICE = gql `
  query getInvoice($invoice_number_check: String_comparison_exp = { _is_null: true }) {
    pay_invoice(where: { invoice_number: $invoice_number_check }) {
      id
      invoice_number
      payment_method
      tax
      type
      user_id
      transaction {
        payment_id
        status
        total_amount
        currency_code
        order {
          id
          entity_name
          order_items {
            coupon_id
            quantity
            total_price
            unit_price
            order_id
            item {
              sku {
                name
                plan_type
                currency_code
                price
              }
              sku_id
              status
            }
            item_id
            is_reschedule
          }
          ordered_by_details {
            email
            id
            name
            timezone
            username
          }
          status
        }
        transaction_status_histories(where: { status_to: { _eq: COMPLETED } }, order_by: { id: desc }) {
          created_at
          id
          status_from
          status_to
        }
        order_id
        purchased_by
      }
    }
  }
`;
export const UPDATE_ORDER_STATUS_MUTATION = gql `
  mutation UpdateOrderStatus(
    $order_id: Int!
    $slot_from: String
    $slot_to: String
    $state: cx_order_state_enum!
    $coupon_code: String
  ) {
    cx_update_order_state(
      order_id: $order_id
      state: $state
      coupon_code: $coupon_code
      slot_from: $slot_from
      slot_to: $slot_to
    ) {
      order_id
      payment_gateway_type
      payment_id
      payment_url
      state
      transaction_external_id
    }
  }
`;
export const INITIATE_TRANSACTION_MUTATION = gql `
  mutation initiateTransaction($orderId: Int!, $coupon_code: String) {
    pay_initiate_transaction(order_id: $orderId, coupon_code: $coupon_code) {
      order_id
      payment_id
      transaction_external_id
      payment_gateway_type
      payment_url
    }
  }
`;
export const PAY_UPDATE_TRANSACTION_STATUS_MUTATION = gql `
  mutation pay_update_transaction_status($paymentId: uuid!, $status: pay_update_transaction_status_enum!) {
    pay_update_transaction(payment_id: $paymentId, status: $status) {
      payment_id
      status
    }
  }
`;
export const SUBSCRIBE_TRANSACTION_STATUS = gql `
  subscription getOrderStatus($order_id: Int) {
    pay_transaction(where: { order_id: { _eq: $order_id } }) {
      currency_code
      payment_id
      external_id
      status
      total_amount
      invoices {
        id
        invoice_number
      }
    }
  }
`;
export const PAY_REQUEST_TRANSACTION_MUTATION = gql `
  mutation requestTransaction($order_id: Int!) {
    pay_request_transaction(order_id: $order_id) {
      order_id
      order_url
      payment_gateway_type
      payment_id
      transaction_external_id
    }
  }
`;
export const DOWNLOAD_TRANSACTION_REPORT = gql `
  query downloadTransactionReport($file_id: Int!) {
    file_download_file(id: $file_id) {
      id
      resource_url
    }
  }
`;
export default {
    GET_ORDER_DETAILS_QUERY,
    CREATE_TRANSACTION_MUTATION,
    VALIDATE_COUPON_MUTATION,
    PAYMENT_RESCHEDULED_SLOT,
    GET_PAYMENT_INVOICE,
    UPDATE_ORDER_STATUS_MUTATION,
    INITIATE_TRANSACTION_MUTATION,
    PAY_UPDATE_TRANSACTION_STATUS_MUTATION,
    SUBSCRIBE_TRANSACTION_STATUS,
    PAY_REQUEST_TRANSACTION_MUTATION,
    DOWNLOAD_TRANSACTION_REPORT,
};
